import { useMutation, useQueryClient } from 'react-query'
import { useToast } from '@dc-shared-web/components/shadcn/use-toast'

import {
  createFolder,
  CreateFolderParams,
} from '@dc-shared-web/hooks/api/folder/createFolder'
import { useFSTrackEvent } from '@dc-shared-web/hooks/api/analytic'
import { FS } from '@dc-shared-web/lib/trackingConstants'
import { useSvcCrunchesContext } from '@dc-shared-web/providers'

export const useCreateFolder = (params?: {
  onSuccess?: () => void
  onError?: () => void
}) => {
  const apiClient = useSvcCrunchesContext()
  const queryClient = useQueryClient()
  const { toast } = useToast()
  const { trackEvent } = useFSTrackEvent()

  return useMutation(
    (mutationParams: CreateFolderParams) =>
      createFolder(apiClient, mutationParams),
    {
      onSuccess: async (_, context) => {
        trackEvent(FS.FOLDER_CREATED)

        await queryClient.invalidateQueries(['folder'])
        await queryClient.invalidateQueries(['project'])
        await queryClient.invalidateQueries(['folders', 'list'])
        await queryClient.invalidateQueries(['folders'])
        await queryClient.invalidateQueries(['projects', 'list'])
        await queryClient.invalidateQueries(['FolderForMove'])
        await queryClient.invalidateQueries(['FolderForMoveTree'])
        await queryClient.invalidateQueries(['foldersList'])

        toast({
          variant: 'success',
          title: `${context.name} folder has been added.`,
        })
        params?.onSuccess?.()
      },
      onError: () => {
        toast({
          variant: 'error',
          title: 'Error creating folder',
          description: 'If the issue persists, please contact support.',
        })
        params?.onError?.()
      },
    }
  )
}
